<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_sl1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('etcOrderDetailList_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('etcOrderDetailList_export_button')"
          @click="funcExport"
          >导出</el-button
        >
        <el-button
          v-if="getLimit('etcOrderDetailList_multiple_search_button')"
          @click="funcMultipleSearch"
          >批量查询发票</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      align="center"
      :loading="loading"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      sort-config.remote
      export-config
      show-overflow
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCodeOrder"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCodeOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运单号"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="etcType"
          title="ETC状态"
          :formatter="formatterEtcType"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.etcType" placeholder="请选择">
            <el-option
              v-for="item in etcTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="etcStatus"
        title="开票状态"
        :formatter="formatterEtcStatus"
        min-width="150"
      />
      <vxe-table-column field="etcFee" title="ETC费用" min-width="200" />
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="发货联系人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入发货联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperPhone"
          title="装货电话"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperPhone"
            placeholder="请输入装货电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperAddress"
          title="装货地址"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperAddress"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="400"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeName"
          title="卸货联系人"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入卸货联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneePhone"
          title="卸货电话"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentPhone"
            placeholder="请输入卸货电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeAddress"
          title="卸货地址"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeAddress"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="400"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('etcOrderDetailList_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('etcOrderDetailList_end_button') &&
                scope.row.etcType == 1
            "
            class="item"
            effect="dark"
            content="ETC开票"
            placement="top"
          >
            <vxe-button type="text" @click="orderDetailEtcEnd(scope.row)">
              <i class="el-icon-position" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('etcOrderDetailList_invoice_button') &&
                (scope.row.etcType == 2 ||
                  scope.row.etcType == 3 ||
                  scope.row.etcType == 5)
            "
            class="item"
            effect="dark"
            content="发票详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="orderDetailEtcInvoice(scope.row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('etcOrderDetailList_longticket_button') &&
                scope.row.etcType == 5
            "
            class="item"
            effect="dark"
            content="查看分单"
            placement="top"
          >
            <vxe-button type="text" @click="orderDeterDeail(scope.row.code)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelInvoice"
      title="ETC发票详情"
      fullscreen
      remember
      width="1000"
      height="80%"
      resize
    >
      <orderDetailEtcInvoice ref="etcInvoiceRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelDistance"
      title="ETC分单详情"
      fullscreen
      remember
      width="1200"
      height="90%"
      resize
    >
      <etcDistanceDetails ref="etcDistanceDetailsRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import ordergoods from "@/components/WaybillDetails";
import orderDetailEtcInvoice from "./orderDetailEtcInvoice";
import etcDistanceDetails from "./etcDistanceDetails";
import request from "@/utils/request";
import { orderEtc, getOrderDetailInvoiceBatch } from "@/api/etc";

export default {
  name: "EtcOrderDetailList",
  components: {
    ordergoods,
    orderDetailEtcInvoice,
    etcDistanceDetails
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      tuteship: false,
      modelDistance: false,
      modelInvoice: false,
      copy: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportEtcOrder", //导出接口
        name: "实时开票"
      },
      listQuery: {
        fillTimeRange: "",
        signTimeRange: "",
        mainOrderNumber: "",
        orderCode: "",
        status: "",
        vehicleLicense: "",
        shipmentName: "",
        shipmentPhone: "",
        shipperAddress: "",
        consigneeName: "",
        consigneePhone: "",
        consigneeAddress: "",
        signTime: "",
        fillTime: "",
        etcType: "",
        code: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        etcStatus: ""
      },
      statusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ],
      etcTypeOptions: [
        { value: 0, label: "未开始" },
        { value: 1, label: "已开始" },
        { value: 2, label: "已结束" },
        { value: 3, label: "已开票" },
        { value: 4, label: "已过期" },
        { value: 5, label: "已分单" },
        { value: 6, label: "无发票" }
      ],
      etcStatusOptions: [
        { value: 3, label: "开票完成" },
        { value: 2, label: "开票中" }
      ],
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        orderEtc(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 批量查询发票
    funcMultipleSearch() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择需要查询的发票", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const orderCodes = selectRecords.map(item => item.orderCode).join(",");
        getOrderDetailInvoiceBatch({ orderCodes }).then(response => {
          rLoading.close();
          let type = response.status === 0 ? "success" : "error";
          this.$message({
            message: response.msg,
            type: type
          });
          this.findList();
        });
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 翻译ETC状态
    formatterEtcType({ cellValue }) {
      const item = this.etcTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译开票状态
    formatterEtcStatus({ cellValue }) {
      const item = this.etcStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    //ETC 开票
    orderDetailEtcEnd(row) {
      this.$confirm("确认要ETC开票？")
        .then(_ => {
          request({
            url: "/ntocc-tms-api/etc/orderDetailEtcEnd",
            method: "post",
            params: {
              code: row.code
            }
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    //ETC详情
    orderDetailEtcInvoice(code) {
      this.$refs.etcInvoiceRef.findInfo(code);
      this.modelInvoice = true;
    },
    //ETC分单详情
    orderDeterDeail(code) {
      this.$refs.etcDistanceDetailsRef.findInfo(code);
      this.modelDistance = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style scoped></style>
